import { React } from 'Imports';
import { Tabs, Tab } from 'MaterialUIComponents';

const sharedStyles = require('./SharedTabs.scss') as {
    tabIndicator: string;
    tabRoot: string;
    flexContainer: string;
    tab: string;
    tabSelected: string;
    tabLabel: string;
    tabRemoveBackground: string;
};

export { sharedStyles as SharedTabStyles };

export interface SharedTabsProps {
    value: string;
    onChange: (event: React.ChangeEvent<object>, newValue: any) => void;
    /** Override the default tab indicator class. When provided, replaces the shared indicator style. */
    indicatorClassName?: string;
    /** Override the default Tabs root class. When provided, replaces the shared root style. */
    rootClassName?: string;
    /** Override the default flex container class. When provided, replaces the shared flex container style. */
    flexContainerClassName?: string;
    children: React.ReactNode;
    removeBackgroundColor?: boolean;
}

export const SharedTabs: React.FC<SharedTabsProps> = ({
    value,
    onChange,
    indicatorClassName,
    rootClassName,
    flexContainerClassName,
    children,
    removeBackgroundColor,
}) => (
    <Tabs
        value={value}
        TabIndicatorProps={{
            className: indicatorClassName ?? sharedStyles.tabIndicator,
        }}
        onChange={onChange}
        classes={{
            flexContainer: flexContainerClassName ?? sharedStyles.flexContainer,
            root: removeBackgroundColor
                ? `${sharedStyles.tabRoot} ${sharedStyles.tabRemoveBackground}`
                : (rootClassName ?? sharedStyles.tabRoot),
        }}
    >
        {children}
    </Tabs>
);

export interface SharedTabProps {
    label: string;
    value: string;
    /** Override the default Tab root class. When provided, replaces the shared tab style. */
    rootClassName?: string;
    /** Override the default Tab selected class. When provided, replaces the shared selected style. */
    selectedClassName?: string;
    removeBackgroundColor?: boolean;
}

export const SharedTab: React.FC<SharedTabProps & Record<string, any>> = ({
    label,
    value,
    rootClassName,
    selectedClassName,
    removeBackgroundColor,
    ...rest
}) => (
    <Tab
        label={
            <span className={sharedStyles.tabLabel} data-text={label}>
                {label}
            </span>
        }
        value={value}
        classes={{
            root: removeBackgroundColor
                ? `${sharedStyles.tab} ${sharedStyles.tabRemoveBackground}`
                : rootClassName
                  ? `${sharedStyles.tab} ${rootClassName}`
                  : sharedStyles.tab,
            selected: selectedClassName ? `${sharedStyles.tabSelected} ${selectedClassName}` : sharedStyles.tabSelected,
        }}
        {...rest}
    />
);
